<template>
    <div>
        <base-input name="organisationName" rules="required|min:4|max:40" label="Organisation name:" v-model="organisation.name"></base-input>

        <div class="form-group">
          <label class="form-control-label">Contact name:</label>
          <validation-provider name="orgContact" rules="required" v-slot="{ validated, errors }">
            <el-autocomplete
              v-model="organisation.orgContact.name"
              @select="(e) => handleSyncDetails(e)"
              @blur="handleAutoCompleteBlur"
              :fetch-suggestions="querySearchAsync"
              value-key="name"
              :trigger-on-focus="false"
              clearable
              class="w-100"
              id="orgContact"
              ref="orgContactRef"
            />
            
            <span id="orgContact" class="text-warning" style="font-size: 80%" v-if="validated && !!errors.length">
              {{ errors[0] }}
            </span>
          </validation-provider>
        </div>

        <base-input name="phone" rules="required|min:8|max:15" label="Phone:" v-model="organisation.phone"></base-input>
        <base-input name="email" rules="email|required|min:5|max:50" label="Email:" v-model="organisation.email"></base-input>

        <h2 class="mb-3">Billing address</h2>
        <form-address @onSetAddress="setAddress" :address="organisation.address"></form-address>

        <div class="mb-3">
          <input type="checkbox" class="mr-2" id="use-for-shipping" @change="handleSameAddressChange">
          <label class="form-control-label" for="use-for-shipping">Use this address for shipping</label>
        </div>

        <h2 class="mb-3">Shipping address</h2>
        <form-address @onSetAddress="setShippingAddress" :address="organisation.shippingAddress"></form-address>

        <div class="mb-3" v-if="isNewEntry">
          <input 
            type="checkbox"
            class="mr-2"
            id="create-defaults"
            :value="createDefaults"
            :checked="createDefaults"
            @change="e => $emit('update:createDefaults', e.target.checked)">
          <label class="form-control-label" for="create-defaults">Create default farm / orchard</label>
        </div>
    </div>
</template>

<script>
import { Autocomplete } from 'element-ui';
import BaseAlert from '../BaseAlert.vue';
import api from '@/api';

export default {
  name: 'form-organisation',
  components: {
    BaseAlert,
    [Autocomplete.name]: Autocomplete,
  },
  props: {
    organisation: {
      type: Object,
      default: null,
      description: ''
    },
    createDefaults: {
      type: Boolean,
      required: false
    },
    isNewEntry: {
      type: Boolean,
      required: false
    }
  },
  data() {
    return {
      // TODO: remove when organsiation.shippingAddress is available
      shippingAddress: {}
    };
  },
  mounted() {
    this.$refs.orgContactRef
      .$el
      .querySelector(':first-child input')
      .classList
      .add('form-control');
  },
  methods: {
    setAddress(address) {
        this.organisation.address = address
    },
    setShippingAddress(address) {
      this.organisation.shippingAddress = address
    },
    async querySearchAsync(queryString, cb) {
      const endpoint = 'getUsers';

      const params = {
        limit: 6,
        direction: 'desc',
        filter: `name: ${queryString}`,
        sort: 'createdOn'
      };

      const results = await api[endpoint](params);

      if (!!results.users.length) {
        cb(results.users);
      } else {
        cb([{ id: 0, name: 'No users found' }]);
      }
    },
    handleSameAddressChange(e) {
      const checked = e.target.checked

      if (checked) {
        this.organisation.shippingAddress = { ...this.organisation.address }
      } else {
        this.organisation.shippingAddress = {}
      }
    },
    
    handleSyncDetails({ id, name }) {
      if (!!id) {
        this.organisation.orgContact = { id, name };

        return false;
      }

      this.organisation.orgContact = {};
    },
    
    handleAutoCompleteBlur() {
      const { id: idExist } = this.organisation.orgContact;
      if (!idExist) {
        this.organisation.orgContact = {};
      }
    },

    handleAutoCompleteInput() {
      const el = this.$refs.orgContactRef.$el
      el.querySelector(':first-child input').classList.add('form-control');
    }
  }
};
</script>